export default __webpack_public_path__ + "static/media/fees.4b2c7ab1.svg";